import { render, staticRenderFns } from "./ClienteRuralTabItem.vue?vue&type=template&id=e3b19660"
import script from "./ClienteRuralTabItem.vue?vue&type=script&lang=js"
export * from "./ClienteRuralTabItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports